<template>
  <button
    type="button"
    :disabled="disabled || loading"
    @click="handleClick"
    class="submit-button"
    :class="{ 'submit-button--loading': loading, 'submit-button--disabled': disabled }"
  >
    <span v-if="loading" class="loading-spinner">
      <i class="fas fa-spinner fa-spin"></i>
    </span>
    <span class="button-text">{{ loading ? 'Processing...' : text }}</span>
  </button>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Submit'
    }
  },
  emits: ['click'],
  methods: {
    handleClick() {
      if (!this.disabled && !this.loading) {
        this.$emit('click');
      }
    }
  }
};
</script>

<style scoped>
.submit-button {
  width: 100%;
  padding: 9px 20px;
  height: 36px;
  background-color: #426a7f;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}


.submit-button:active:not(.submit-button--disabled):not(.submit-button--loading) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 94, 184, 0.3);
}

.submit-button--disabled,
.submit-button--loading {
  background-color: #BFC1C3;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.submit-button--loading {
  opacity: 0.8;
  cursor: wait;
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner i {
  font-size: 16px;
}

.button-text {
  white-space: nowrap;
}

/* Focus styles for accessibility */
.submit-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.3);
}

.submit-button:focus:not(.submit-button--disabled):not(.submit-button--loading) {
  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.3), 0 4px 8px rgba(0, 94, 184, 0.3);
}
</style>